<template>
  <v-snackbar v-model="alert.status" :timeout="timeout" :color="alert.type" top>
    {{ alert.message }}
    <v-btn dark flat @click="clear">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      timeout: 6000,
    }
  },
  computed: {
    ...mapGetters({
      alert: 'Alert/get',
    }),
    show: {
      get: function() {
        return this.alert
      },
      set: function() {
        this.clear()
      },
    },
  },
  methods: {
    ...mapActions({
      clear: 'Alert/clear',
    }),
  },
}
</script>
